import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";

const YearOption = ({ selectedYear, yearSelectHandler }) => {
  const userData = useSelector(loggedInUser);
  const currentYear = new Date().getFullYear();
  const startYear = Number(userData?.companyStartYear);

  const options = [];
  for (let y = currentYear; y >= startYear; y--) {
    options.push({ value: y, label: y.toString() });
  }

  return (
    <Select
      options={options}
      value={options.find((opt) => opt.value === selectedYear)}
      onChange={(selected) => yearSelectHandler(selected.value)}
      placeholder="Select Year"
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
    />
  );
};

YearOption.propTypes = {
  selectedYear: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  yearSelectHandler: PropTypes.func,
  // companyStartedYear: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default YearOption;
